import { ClassNames } from '@emotion/react';
import { Skeleton } from './ui/skeleton';

export const StatCardsSkeleton = ({ count = 3, columns = 'sm:grid-cols-2 xl:grid-cols-4' }) => (
  <section className={`grid gap-4 ${columns}`}>
    {Array.from({ length: count }, (_, index) => (
      <div key={index} className="rounded-xl border border-slate-200/80 bg-white p-5 shadow-sm">
        <Skeleton height={12} width="55%" />
        <Skeleton className="mt-3" height={32} width={64} />
      </div>
    ))}
  </section>
);

export const TableSkeleton = ({ rows = 5, columns = 5 }) => (
  <ClassNames>
    {({ css }) => (
      <div className="px-6 pb-6">
        <div className="overflow-hidden rounded-lg border border-slate-200">
          <div className={`grid gap-3 border-b border-slate-200 bg-slate-50 px-4 py-3 ${css({ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` })}`}>
            {Array.from({ length: columns }, (_, index) => (
              <Skeleton key={index} height={12} width="70%" />
            ))}
          </div>
          {Array.from({ length: rows }, (_row, rowIndex) => (
            <div key={rowIndex} className={`grid gap-3 border-b border-slate-100 px-4 py-4 last:border-b-0 ${css({ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` })}`}>
              {Array.from({ length: columns }, (_col, colIndex) => (
                <Skeleton key={colIndex} height={14} width={colIndex === 0 ? '80%' : '60%'} />
              ))}
            </div>
          ))}
        </div>
      </div>
    )}
  </ClassNames>
);

export const VehicleListSkeleton = ({ rows = 6 }) => (
  <div className="space-y-2">
    {Array.from({ length: rows }, (_, index) => (
      <div key={index} className="rounded-lg border border-slate-200/80 p-3.5">
        <div className="flex items-start justify-between gap-2">
          <Skeleton height={16} width={120} />
          <Skeleton height={20} width={72} borderRadius="9999px" />
        </div>
        <Skeleton className="mt-2" height={12} width="75%" />
        <Skeleton className="mt-2" height={12} width="45%" />
      </div>
    ))}
  </div>
);

export const VehicleWorkspaceSkeleton = () => (
  <div className="grid gap-6 lg:grid-cols-[minmax(300px,380px)_minmax(300px,1fr)]">
    <div className="tm-plate tm-plate--loading">
      <div className="tm-plate__head"><Skeleton height={9} width={150} /></div>
      <div className="tm-plate__stage min-h-[320px] items-center">
        <Skeleton height={280} width={150} borderRadius="1rem" />
      </div>
      <div className="tm-plate__legend">
        {Array.from({ length: 6 }, (_, index) => (
          <span key={index} className="tm-plate__legend-item"><Skeleton height={10} width={index % 3 === 1 ? 92 : 68} /></span>
        ))}
      </div>
    </div>
    <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
      <Skeleton height={18} width={230} />
      <Skeleton className="mt-2" height={13} width="85%" />
      <div className="mt-4 space-y-2">
        {Array.from({ length: 3 }, (_, index) => (
          <div key={index} className="flex items-center gap-3 rounded-lg border border-slate-200 bg-white p-3.5">
            <Skeleton height={22} width={46} borderRadius="0.375rem" />
            <Skeleton height={14} width={110} />
            <div className="ml-auto"><Skeleton height={22} width={78} borderRadius="9999px" /></div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export const SetupVehicleListSkeleton = ({ rows = 8 }) => (
  <div className="space-y-2">
    {Array.from({ length: rows }, (_, index) => (
      <div key={index} className="flex items-start gap-3 rounded-lg border border-slate-200/80 p-4">
        <Skeleton height={16} width={16} />
        <div className="min-w-0 flex-1">
          <Skeleton height={16} width={140} />
          <Skeleton className="mt-2" height={12} width="65%" />
        </div>
      </div>
    ))}
  </div>
);
